import { render, staticRenderFns } from "./menu_sports.vue?vue&type=template&id=e08ff810"
import script from "./menu_sports.vue?vue&type=script&lang=js"
export * from "./menu_sports.vue?vue&type=script&lang=js"
import style0 from "./menu_sports.vue?vue&type=style&index=0&id=e08ff810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports